// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/AkayaTelivigala-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/AkayaTelivigala-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/nocturn-sky.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/Clear.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/cloud.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/Rain.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/Storm.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../img/partly.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-pri: #162938;
  --color-pri-t: #1629387a;
  --color-sec: #213d536c;
  --color-tri: #1b3b536c;
  --color-qua: #b1c5d3;
  --size-pri: clamp(1rem, 0.8rem + 0.4vw, 1.2rem);
  --radius-pri: 10px;
  --filter-color-pri: brightness(0) saturate(100%) invert(13%) sepia(12%)
    saturate(2179%) hue-rotate(165deg) brightness(97%) contrast(95%);
  --filter-color-qua: brightness(0) saturate(100%) invert(80%) sepia(16%)
    saturate(287%) hue-rotate(162deg) brightness(97%) contrast(86%);
  --width-mobile: 90vw;
  --width-tablet: 80vw;
  --width-laptop: 60vw;
  font-family:
    "Akaya Telivigala",
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    "Open Sans",
    "Helvetica Neue",
    sans-serif;
  letter-spacing: 0.1em;
  line-height: 1.3em;
}

@font-face {
  font-family: "Akaya";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

* {
  color: var(--color-qua);
}

body {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  place-content: center;
  -ms-overflow-style: none;
}

::-webkit-scrollbar {
  display: none;
}

::-webkit-scrollbar-button {
  display: none;
}

button {
  height: 100%;
  width: 100%;
  background: none;
  border: none;
}

button:hover {
  cursor: pointer;
}

a {
  text-decoration: none;
  margin-left: 1rem;
}

.default {
  background:
    linear-gradient(
      145deg,
      transparent 0%,
      var(--color-pri-t) 30%,
      var(--color-pri) 60%
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.clear {
  background:
    linear-gradient(
      145deg,
      transparent 0%,
      var(--color-pri-t) 30%,
      var(--color-pri) 60%
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.cloud {
  background:
    linear-gradient(
      145deg,
      transparent 0%,
      var(--color-pri-t) 30%,
      var(--color-pri) 60%
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.rain {
  background:
    linear-gradient(
      145deg,
      transparent 0%,
      var(--color-pri-t) 30%,
      var(--color-pri) 60%
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.storm {
  background:
    linear-gradient(
      145deg,
      transparent 0%,
      var(--color-pri-t) 30%,
      var(--color-pri) 60%
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.partly {
  background:
    linear-gradient(
      145deg,
      transparent 0%,
      var(--color-pri-t) 30%,
      var(--color-pri) 60%
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.defautlt,
.clear,
.cloud,
.rain,
.storm,
.partly {
  background-size: cover;
  background-repeat: no-repeat;
}

/* .wind {
    background: linear-gradient(145deg, transparent 0%, var(--color-pri-t) 30%, var(--color-pri) 60%),
        url("../img/wind.jpg");
    background-size: cover;
    background-repeat: no-repeat;
} */

.hello-message {
  margin: auto;
  text-align: center;
  padding-bottom: 5rem;
  font-size: calc(4 * var(--size-pri));
  font-weight: 900;
  text-wrap: balance;
  line-height: 4rem;
}

.search-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: var(--size-pri) auto;
  width: var(--width-mobile);
  max-height: 5vh;

  img {
    position: absolute;
    right: 2%;
    height: 80%;
    filter: var(--filter-color-qua);
  }

  img:hover {
    cursor: pointer;
  }

  input {
    width: 100%;
    border-radius: var(--radius-pri);
    background-color: var(--color-sec);
    border: none;
    padding: 0.3em;
    font-size: calc(1.5 * var(--size-pri));
    letter-spacing: 0.15em;
    position: relative;
    text-align: center;
  }

  input:focus {
    outline: 2px solid var(--color-qua);
  }

  input::placeholder {
    color: inherit;
    opacity: 70%;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill-selected {
    background-color: var(--color-sec) !important;
  }
}

.alert-box {
  text-align: center;
  position: absolute;
  bottom: -3em;
  background-color: rgba(155, 76, 76, 0.356);
  padding: 0.5em;
  border-radius: var(--radius-pri);
}

.weather-container {
  margin: 0 auto var(--size-pri) auto;
  width: var(--width-mobile);
  max-height: 90%;
  border-radius: var(--radius-pri);
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: 1fr 3fr min-content;
  row-gap: var(--size-pri);
  column-gap: calc(2 * var(--size-pri));

  * {
    border-radius: inherit;
    gap: calc(0.5 * var(--size-pri));
  }

  > div {
    background-color: var(--color-sec);
  }

  img {
    filter: var(--filter-color-qua);
  }
}

.weather-header {
  grid-area: 1 / 1 / 2 / -1;
  display: grid;
  grid-template: 1fr 1fr / 1fr 1fr;
  font-size: calc(1.2 * var(--size-pri));

  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: calc(0.5 * var(--size-pri));

    * {
      font-size: calc(1.5 * var(--size-pri));
      line-height: 1em;
    }
  }
}

.weather-header1 {
  grid-area: 2 / 1 / 3 / 2;
}

.weather-header2 {
  grid-area: 1 / 1 / 2 / -1;
  position: relative;

  > div {
    font-size: calc(2 * var(--size-pri));
    font-weight: 700;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  > div:hover {
    overflow: visible;
    position: absolute;
    white-space: wrap;
    color: var(--color-qua);
    background-color: var(--color-sec);
    max-width: 80%;
    text-wrap: balance;
    padding: 0.3em;
    top: 0;
    z-index: 1;
  }
}

.weather-current {
  grid-area: 2 / 1 / 3 / -1;
  display: grid;
  grid-template: repeat(2, 1fr) / 1fr 1fr;
  grid-auto-rows: 1fr;

  img {
    width: 35%;
  }

  button {
    grid-area: 1 / 1 / -1 / -1;
    padding: 0;
    font-size: calc(2.5 * var(--size-pri));
    font-weight: 700;
    display: grid;
    grid-template-rows: subgrid;

    :first-child {
      place-self: center;
    }
  }

  > div {
    display: grid;
    grid-template-rows: 2fr 1fr;
    place-items: center;

    :nth-child(2) {
      align-self: flex-start;
      font-size: calc(1.3 * var(--size-pri));
    }

    * {
      flex: 1;
      text-align: center;
    }
  }
}

.weather-forecast {
  grid-area: 3 / 1 / 4 / -1;
  display: grid;
  grid-template: repeat(2, 1fr) / repeat(auto-fit, minmax(100px, 30%));
  place-content: center;
  padding: calc(0.5 * var(--size-pri));
  gap: calc(2 * var(--size-pri));
  width: 100%;

  > * {
    display: grid;
    grid-template-rows: 1fr 1.5fr 1fr 1fr;
    place-items: center;
    padding: var(--size-pri);
  }

  > * > * {
    display: flex;
    align-items: center;
    text-align: center;

    img {
      scale: 1.5;
    }
  }
}

.forecast-day {
  font-weight: 700;
}

.forecast-conditions {
  font-size: 0.8rem;
  align-self: first baseline;
}

.forecast-tempMaxMin {
  display: block;
}

.weather-header,
.weather-current,
.weather-forecast {
  > div:hover {
    box-shadow: 0.2em 0.2em 0.6em 0.6em var(--color-pri);

    * {
      transform: scale(1.1);
    }
  }

  > div > * {
    transition: transform 0.5s ease;
  }
}

footer {
  height: 5vh;
  width: 100vw;
  font-size: calc(0.8 * var(--size-pri));
  color: white;
  background-color: var(--clr-sec);
  position: fixed;
  z-index: 100;
  opacity: 0.5;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.animate-search {
  animation: slideIn 1s ease;
}

.blur {
  filter: blur(5px);
}

.loading-gif {
  position: absolute;
  left: 2%;
  height: 90%;
  aspect-ratio: 1 / 1;
}

@keyframes slideIn {
  from {
    opacity: 30%;
    transform: translateY(50vh);
  }

  to {
    opacity: 100%;
    transform: translateY(0);
  }
}

@media (min-width: 900px) {
  .search-container {
    width: var(--width-tablet);
  }

  .weather-container {
    width: var(--width-tablet);
    min-height: 80vh;
  }

  .weather-header {
    display: grid;
    grid-template: 1fr / 1fr 2fr 1fr;
  }

  .weather-header1 {
    grid-column: span 1;
    grid-area: 1 / 1 / 2 / 2;
  }

  .weather-header2 {
    grid-column: span 1;

    > div {
      max-width: 20ch;
    }
  }

  .weather-current {
    display: grid;
    grid-template: 1fr / repeat(4, 1fr);
  }

  .weather-forecast {
    display: grid;
    grid-template: 1fr / repeat(6, 1fr);
    column-gap: 0;
  }
}

@media (min-width: 1200px) {
  .search-container {
    width: var(--width-laptop);
  }

  .weather-container {
    width: var(--width-laptop);
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/main-style.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,+CAA+C;EAC/C,kBAAkB;EAClB;oEACkE;EAClE;mEACiE;EACjE,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB;;;;;;;;;;;;cAYY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB;;0DAE6D;EAC7D,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE;;;;;;;2CAO+B;AACjC;;AAEA;EACE;;;;;;;2CAOyB;AAC3B;;AAEA;EACE;;;;;;;2CAOyB;AAC3B;;AAEA;EACE;;;;;;;2CAOwB;AAC1B;;AAEA;EACE;;;;;;;2CAOyB;AAC3B;;AAEA;EACE;;;;;;;2CAO0B;AAC5B;;AAEA;;;;;;EAME,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;;;;;GAKG;;AAEH;EACE,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;;EAEf;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,+BAA+B;EACjC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gCAAgC;IAChC,kCAAkC;IAClC,YAAY;IACZ,cAAc;IACd,sCAAsC;IACtC,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;;;;IAIE,6CAA6C;EAC/C;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;EAC1C,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,qCAAqC;EACrC,uCAAuC;EACvC,wBAAwB;EACxB,qCAAqC;;EAErC;IACE,sBAAsB;IACtB,gCAAgC;EAClC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gCAAgC;EAChC,sCAAsC;;EAEtC;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,oCAAoC;;IAEpC;MACE,sCAAsC;MACtC,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;;EAElB;IACE,oCAAoC;IACpC,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,kCAAkC;IAClC,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,MAAM;IACN,UAAU;EACZ;AACF;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,uCAAuC;EACvC,mBAAmB;;EAEnB;IACE,UAAU;EACZ;;EAEA;IACE,0BAA0B;IAC1B,UAAU;IACV,sCAAsC;IACtC,gBAAgB;IAChB,aAAa;IACb,2BAA2B;;IAE3B;MACE,kBAAkB;IACpB;EACF;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;;IAEnB;MACE,sBAAsB;MACtB,sCAAsC;IACxC;;IAEA;MACE,OAAO;MACP,kBAAkB;IACpB;EACF;AACF;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,oEAAoE;EACpE,qBAAqB;EACrB,oCAAoC;EACpC,8BAA8B;EAC9B,WAAW;;EAEX;IACE,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;;IAElB;MACE,UAAU;IACZ;EACF;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE;IACE,oDAAoD;;IAEpD;MACE,qBAAqB;IACvB;EACF;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;;IAEnB;MACE,eAAe;IACjB;EACF;;EAEA;IACE,aAAa;IACb,mCAAmC;EACrC;;EAEA;IACE,aAAa;IACb,mCAAmC;IACnC,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[":root {\n  --color-pri: #162938;\n  --color-pri-t: #1629387a;\n  --color-sec: #213d536c;\n  --color-tri: #1b3b536c;\n  --color-qua: #b1c5d3;\n  --size-pri: clamp(1rem, 0.8rem + 0.4vw, 1.2rem);\n  --radius-pri: 10px;\n  --filter-color-pri: brightness(0) saturate(100%) invert(13%) sepia(12%)\n    saturate(2179%) hue-rotate(165deg) brightness(97%) contrast(95%);\n  --filter-color-qua: brightness(0) saturate(100%) invert(80%) sepia(16%)\n    saturate(287%) hue-rotate(162deg) brightness(97%) contrast(86%);\n  --width-mobile: 90vw;\n  --width-tablet: 80vw;\n  --width-laptop: 60vw;\n  font-family:\n    \"Akaya Telivigala\",\n    system-ui,\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    Roboto,\n    Oxygen,\n    Ubuntu,\n    Cantarell,\n    \"Open Sans\",\n    \"Helvetica Neue\",\n    sans-serif;\n  letter-spacing: 0.1em;\n  line-height: 1.3em;\n}\n\n@font-face {\n  font-family: \"Akaya\";\n  src:\n    url(\"../fonts/AkayaTelivigala-Regular.woff2\") format(\"woff2\"),\n    url(\"../fonts/AkayaTelivigala-Regular.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n* {\n  color: var(--color-qua);\n}\n\nbody {\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n  place-content: center;\n  -ms-overflow-style: none;\n}\n\n::-webkit-scrollbar {\n  display: none;\n}\n\n::-webkit-scrollbar-button {\n  display: none;\n}\n\nbutton {\n  height: 100%;\n  width: 100%;\n  background: none;\n  border: none;\n}\n\nbutton:hover {\n  cursor: pointer;\n}\n\na {\n  text-decoration: none;\n  margin-left: 1rem;\n}\n\n.default {\n  background:\n    linear-gradient(\n      145deg,\n      transparent 0%,\n      var(--color-pri-t) 30%,\n      var(--color-pri) 60%\n    ),\n    url(\"../img/nocturn-sky.jpg\");\n}\n\n.clear {\n  background:\n    linear-gradient(\n      145deg,\n      transparent 0%,\n      var(--color-pri-t) 30%,\n      var(--color-pri) 60%\n    ),\n    url(\"../img/Clear.jpg\");\n}\n\n.cloud {\n  background:\n    linear-gradient(\n      145deg,\n      transparent 0%,\n      var(--color-pri-t) 30%,\n      var(--color-pri) 60%\n    ),\n    url(\"../img/cloud.jpg\");\n}\n\n.rain {\n  background:\n    linear-gradient(\n      145deg,\n      transparent 0%,\n      var(--color-pri-t) 30%,\n      var(--color-pri) 60%\n    ),\n    url(\"../img/Rain.jpg\");\n}\n\n.storm {\n  background:\n    linear-gradient(\n      145deg,\n      transparent 0%,\n      var(--color-pri-t) 30%,\n      var(--color-pri) 60%\n    ),\n    url(\"../img/Storm.jpg\");\n}\n\n.partly {\n  background:\n    linear-gradient(\n      145deg,\n      transparent 0%,\n      var(--color-pri-t) 30%,\n      var(--color-pri) 60%\n    ),\n    url(\"../img/partly.jpg\");\n}\n\n.defautlt,\n.clear,\n.cloud,\n.rain,\n.storm,\n.partly {\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n/* .wind {\n    background: linear-gradient(145deg, transparent 0%, var(--color-pri-t) 30%, var(--color-pri) 60%),\n        url(\"../img/wind.jpg\");\n    background-size: cover;\n    background-repeat: no-repeat;\n} */\n\n.hello-message {\n  margin: auto;\n  text-align: center;\n  padding-bottom: 5rem;\n  font-size: calc(4 * var(--size-pri));\n  font-weight: 900;\n  text-wrap: balance;\n  line-height: 4rem;\n}\n\n.search-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  margin: var(--size-pri) auto;\n  width: var(--width-mobile);\n  max-height: 5vh;\n\n  img {\n    position: absolute;\n    right: 2%;\n    height: 80%;\n    filter: var(--filter-color-qua);\n  }\n\n  img:hover {\n    cursor: pointer;\n  }\n\n  input {\n    width: 100%;\n    border-radius: var(--radius-pri);\n    background-color: var(--color-sec);\n    border: none;\n    padding: 0.3em;\n    font-size: calc(1.5 * var(--size-pri));\n    letter-spacing: 0.15em;\n    position: relative;\n    text-align: center;\n  }\n\n  input:focus {\n    outline: 2px solid var(--color-qua);\n  }\n\n  input::placeholder {\n    color: inherit;\n    opacity: 70%;\n  }\n\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  input:-webkit-autofill-selected {\n    background-color: var(--color-sec) !important;\n  }\n}\n\n.alert-box {\n  text-align: center;\n  position: absolute;\n  bottom: -3em;\n  background-color: rgba(155, 76, 76, 0.356);\n  padding: 0.5em;\n  border-radius: var(--radius-pri);\n}\n\n.weather-container {\n  margin: 0 auto var(--size-pri) auto;\n  width: var(--width-mobile);\n  max-height: 90%;\n  border-radius: var(--radius-pri);\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  grid-template-rows: 1fr 3fr min-content;\n  row-gap: var(--size-pri);\n  column-gap: calc(2 * var(--size-pri));\n\n  * {\n    border-radius: inherit;\n    gap: calc(0.5 * var(--size-pri));\n  }\n\n  > div {\n    background-color: var(--color-sec);\n  }\n\n  img {\n    filter: var(--filter-color-qua);\n  }\n}\n\n.weather-header {\n  grid-area: 1 / 1 / 2 / -1;\n  display: grid;\n  grid-template: 1fr 1fr / 1fr 1fr;\n  font-size: calc(1.2 * var(--size-pri));\n\n  > div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    padding: calc(0.5 * var(--size-pri));\n\n    * {\n      font-size: calc(1.5 * var(--size-pri));\n      line-height: 1em;\n    }\n  }\n}\n\n.weather-header1 {\n  grid-area: 2 / 1 / 3 / 2;\n}\n\n.weather-header2 {\n  grid-area: 1 / 1 / 2 / -1;\n  position: relative;\n\n  > div {\n    font-size: calc(2 * var(--size-pri));\n    font-weight: 700;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  > div:hover {\n    overflow: visible;\n    position: absolute;\n    white-space: wrap;\n    color: var(--color-qua);\n    background-color: var(--color-sec);\n    max-width: 80%;\n    text-wrap: balance;\n    padding: 0.3em;\n    top: 0;\n    z-index: 1;\n  }\n}\n\n.weather-current {\n  grid-area: 2 / 1 / 3 / -1;\n  display: grid;\n  grid-template: repeat(2, 1fr) / 1fr 1fr;\n  grid-auto-rows: 1fr;\n\n  img {\n    width: 35%;\n  }\n\n  button {\n    grid-area: 1 / 1 / -1 / -1;\n    padding: 0;\n    font-size: calc(2.5 * var(--size-pri));\n    font-weight: 700;\n    display: grid;\n    grid-template-rows: subgrid;\n\n    :first-child {\n      place-self: center;\n    }\n  }\n\n  > div {\n    display: grid;\n    grid-template-rows: 2fr 1fr;\n    place-items: center;\n\n    :nth-child(2) {\n      align-self: flex-start;\n      font-size: calc(1.3 * var(--size-pri));\n    }\n\n    * {\n      flex: 1;\n      text-align: center;\n    }\n  }\n}\n\n.weather-forecast {\n  grid-area: 3 / 1 / 4 / -1;\n  display: grid;\n  grid-template: repeat(2, 1fr) / repeat(auto-fit, minmax(100px, 30%));\n  place-content: center;\n  padding: calc(0.5 * var(--size-pri));\n  gap: calc(2 * var(--size-pri));\n  width: 100%;\n\n  > * {\n    display: grid;\n    grid-template-rows: 1fr 1.5fr 1fr 1fr;\n    place-items: center;\n    padding: var(--size-pri);\n  }\n\n  > * > * {\n    display: flex;\n    align-items: center;\n    text-align: center;\n\n    img {\n      scale: 1.5;\n    }\n  }\n}\n\n.forecast-day {\n  font-weight: 700;\n}\n\n.forecast-conditions {\n  font-size: 0.8rem;\n  align-self: first baseline;\n}\n\n.forecast-tempMaxMin {\n  display: block;\n}\n\n.weather-header,\n.weather-current,\n.weather-forecast {\n  > div:hover {\n    box-shadow: 0.2em 0.2em 0.6em 0.6em var(--color-pri);\n\n    * {\n      transform: scale(1.1);\n    }\n  }\n\n  > div > * {\n    transition: transform 0.5s ease;\n  }\n}\n\nfooter {\n  height: 5vh;\n  width: 100vw;\n  font-size: calc(0.8 * var(--size-pri));\n  color: white;\n  background-color: var(--clr-sec);\n  position: fixed;\n  z-index: 100;\n  opacity: 0.5;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.animate-search {\n  animation: slideIn 1s ease;\n}\n\n.blur {\n  filter: blur(5px);\n}\n\n.loading-gif {\n  position: absolute;\n  left: 2%;\n  height: 90%;\n  aspect-ratio: 1 / 1;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 30%;\n    transform: translateY(50vh);\n  }\n\n  to {\n    opacity: 100%;\n    transform: translateY(0);\n  }\n}\n\n@media (min-width: 900px) {\n  .search-container {\n    width: var(--width-tablet);\n  }\n\n  .weather-container {\n    width: var(--width-tablet);\n    min-height: 80vh;\n  }\n\n  .weather-header {\n    display: grid;\n    grid-template: 1fr / 1fr 2fr 1fr;\n  }\n\n  .weather-header1 {\n    grid-column: span 1;\n    grid-area: 1 / 1 / 2 / 2;\n  }\n\n  .weather-header2 {\n    grid-column: span 1;\n\n    > div {\n      max-width: 20ch;\n    }\n  }\n\n  .weather-current {\n    display: grid;\n    grid-template: 1fr / repeat(4, 1fr);\n  }\n\n  .weather-forecast {\n    display: grid;\n    grid-template: 1fr / repeat(6, 1fr);\n    column-gap: 0;\n  }\n}\n\n@media (min-width: 1200px) {\n  .search-container {\n    width: var(--width-laptop);\n  }\n\n  .weather-container {\n    width: var(--width-laptop);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
